module.exports = __webpack_public_path__ + "img/lianrun01.2ac1909a.png";